namespace $.$$ {

	export class $shm_hitalama_profile_switch extends $.$shm_hitalama_profile_switch {

		login(): string {
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		avatar_uri() {
			return this.$.$shm_hitalama_profile.avatar_uri(
				this.$.$shm_hitalama_profile.current()?.Avatar()?.remote(),
			)
		}

		client_id(): string {
			return this.$.$giper_baza_auth.current().pass().lord().str
		}

		sub(): readonly ( any )[] {
			return this.login() ? super.sub() : this.buttons()
		}

		@ $mol_action
		exit() {
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) {
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( true )
			}
			const auth = this.$.$mol_error_fence(
				()=> this.$.$giper_baza_auth.grab(),
				error => this.$.$shm_hitalama_compat_crypto_error( error ),
			)
			this.$.$giper_baza_auth.current( auth )
			this.$.$shm_hitalama_profile.home().Hitalama_profile(null)?.remote( null )
		}
	}

}
